module.exports = __webpack_public_path__ + "img/1.411ea0e5.png";